<template>
	<div>
		<h1>Study Selection and Screening</h1>

		

		<InputSelectMultiWithoutOthers
			question="Which authors screened title/abstract?"
			v-model="$tera.project.titleAbstractScreeners"
			:options="
				/*titlepage.authors.map(el => {
					return { label: el };
				})*/
				this.scabstractAuthors
			"
			questionMark="studyscreening-2"
		/>
		<InputTextNumber
			question="The number of review authors who independently screened the titles and abstracts for inclusion against the inclusion criteria was"
			v-model="numberOfTitleAbstractScreeners"
			:disabled="disabled"
			questionMark="studyscreening-1"
		/>
		<InputSelectMultiWithoutOthers
			question="Which author retrieved full-texts?"
			v-model="$tera.project.fullTextRetrivalAuthor"
			:options="this.retrfulltextAuthors"
			questionMark="obtfulltext-1"
		/>

		
		<InputSelectMultiWithoutOthers
			question="Which authors screened full-texts?"
			v-model="$tera.project.fullTextScreeners"
			:options="
				/*titlepage.authors.map(el => {
					return { label: el };
				})*/
				this.scfulltextAuthors
			"
			questionMark="scrfulltext-2"
		/>
		<InputTextNumber
			question="The number of review authors who independently screened the full-texts for inclusion was"
			v-model="numberOfFullTextScreeners"
			:disabled="disabled"
			questionMark="scrfulltext-1"
		/>
		<InputSelectMultiWithoutOthers
			question="Who screened the citation search?"
			v-model="$tera.project.screenCitationSearchPeople"
			:options="this.scCitSearchPeople"
                  questionMark="scrcitation-1"
		/>

		<InputSelectMultiWithoutOthers
			question="Who screened trial registries?"
			v-model="$tera.project.screenTrialRegisPeople"
			:options="this.scTrialRegisPeople"
                  questionMark="scrregistries-1"
		/>

		<InputSelectMulti
			question="Any disagreements were resolved by:"
			v-model="$tera.project.disputeResolution"
			:options="disputeResolutionOptions"
			questionMark="studyscreening-3"
		/>

		<InputSelectMulti
			question="Which tool/s, if any, were used to help with screening?"
			v-model="$tera.project.screeningToolsSelected"
			:options="screeningTools"
			questionMark="studyscreening-4"
		/>

		<InputSelectYesNo
			question="This systematic review is reported following the Preferred Reporting Items for Systematic Reviews and Meta-Analyses (PRISMA) statement."
			v-model="$tera.project.isPrismaFlowDiagram"
		/>

		<InputSelectYesNo
			v-if="$tera.project.isPrismaFlowDiagram"
			question="The list of studies excluded at full-text is provided in Appendix"
			v-model="$tera.project.isExcludedFullTextInAppendix"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputScreening from "./OutputScreening.vue";
import BasePreviewOutput from "@/components/BasePreviewOutput.vue";
import InputSelectMulti from "@/components/InputSelectMulti.vue";
import InputSelectMultiWithoutOthers from "@/components/InputSelectMultiWithoutOther.vue";
import InputSelectYesNo from "@/components/InputSelectYesNo.vue";

export default {
	name: "ViewMethodScreening",

	components: {
		InputSelectMulti,
		InputSelectMultiWithoutOthers,
		InputSelectYesNo,
		BasePreviewOutput
	},
	computed: {
		numberOfTitleAbstractScreeners() {
			return this.$tera.project.titleAbstractScreeners?.length;
		},
		numberOfFullTextScreeners() {
			return this.$tera.project.fullTextScreeners?.length;
		},
		scTrialRegisPeople() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Screen trial registries" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		},
		scCitSearchPeople() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Screen citation analysis" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		},
		scabstractAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Screen abstracts" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		},
		scfulltextAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Screen full text" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		},
		retrfulltextAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Obtain full text" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		}
	},
	methods: {
		checkUnion(U) {
			for (var i = 0; i < U.length; i++) {
				for (var j = i + 1; j < U.length; j++) {
					if (U[i].label == U[j].label) {
						U.splice(j, 1);
						j--;
					}
				}
			}
		}
	},
	data() {
		return {
			numberOptions: ["2", "3", "4", "5", "6"],
			disputeResolutionOptions: [
				{ label: "By consensus" },
				{ label: "By referring to a third author" }
			],
			screeningTools: [
				{ label: "Screenatron" },
				{ label: "Covidence" },
				{ label: "Rayyan" },
				{ label: "EPPI-Reviewer" },
				{ label: "MechaScreener" },
				{ label: "The Evidence Review Accelerator" }
			],
			outputComponent: OutputScreening,
			disabled:true
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
